import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { useEffect } from 'react';
const mopinionID = 'ONuYWSYfJm5vUYcZcz4dH9mmgnI9RwiQMsQLgwXP';
export type MopinionSRV = {
  ALL_KEYS: Array<string>;
  /** Boolean show is ignored by Mopinion */
  openModal: (show: boolean, id: string) => void;
  closeModal: (id: string) => void;
};
declare global {
  interface Window {
    Pastease?: {
      load: (id: string) => void;
    };
    srv?: MopinionSRV;
  }
}
/**
 * 1. Insert mopinion script
 * 2. Wait for script to be loaded
 * 3. Load Mopinion deployment
 * 4. Wait for deployment to be loaded
 * 5. Safe srv object for parent component to use
 */
export const LoadMopinion = t0 => {
  const $ = _c(4);
  const {
    setSRV
  } = t0;
  let t1;
  let t2;
  if ($[0] !== setSRV) {
    t1 = () => {
      if (window.srv != null) {
        setSRV(window.srv);
        return;
      }
      const abortController = new AbortController();
      document.addEventListener("mopinion_loaded", () => {
        if (window.srv != null) {
          setSRV(window.srv);
          abortController.abort();
        }
      }, {
        signal: abortController.signal
      });
      return () => {
        abortController.abort();
      };
    };
    t2 = [setSRV];
    $[0] = setSRV;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (window.srv != null) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Script src="https://deploy.mopinion.com/js/pastease.js" onLoad={_temp} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp() {
  if ("Pastease" in window && window.Pastease != null && typeof window.Pastease === "object" && "load" in window.Pastease && typeof window.Pastease.load === "function") {
    window.Pastease.load(mopinionID);
  }
}